import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import GenericModal from '../GenericModal';
import CrossCloseIcon from '@components/UI/CrossCloseIcon';
const useStyles = makeStyles()((theme) => ({
    closeIcon: {
        marginLeft: 'auto',
    },
    downloadIcon: {
        width: '80%',
        margin: '0 auto',
        padding: theme.spacing(2.5, 5),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0.5, 5),
        },
    },
    subtext: {
        fontSize: 14,
    },
    container: {
        fontFamily: 'Montserrat',
    },
    badge: {
        maxHeight: 60,
    },
    downloadModalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        padding: theme.spacing(0, 3, 3),
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(0, 2, 3),
            gap: 15,
        },
        '& h2': {
            color: '#1D2128',
            fontSize: 20,
            fontWeight: 600,
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: 17,
            },
        },
    },
    actionBtn: {
        borderRadius: 4,
        color: '#9D9D9D',
        display: 'flex',
        justifyContent: 'center',
        justifySelf: 'flex-end',
        alignItems: 'center',
        height: 45,
        fontWeight: 600,
        fontSize: 12,
        border: '1px solid #EBEBEB',
        background: '#F9F9F9',
    },
    appBrandWrapper: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'space-between',
        },
    },
}));
export const RepeatAppDownloadModal = ({ show, handleClose }) => {
    const { classes } = useStyles();
    const openGooglePlayURL = () => {
        globalThis.open(process.env.REPEAT_APP_DOWNLOAD_GOOGLE_PLAY_URL, '_blank');
    };
    const openAppStoreURL = () => {
        globalThis.open(process.env.REPEAT_APP_DOWNLOAD_APP_STORE_URL, '_blank');
    };
    return (_jsxs(GenericModal, { size: "medium", show: show, "data-testid": "app download modal", mobileFullScreen: false, children: [_jsx(CrossCloseIcon, { action: handleClose, className: classes.closeIcon }), _jsx("div", { className: classes.container, children: _jsxs("div", { className: classes.downloadModalContent, children: [_jsx("img", { src: "/img/mobile-app-promotions/download-icon.png", alt: "Download Mobile App", className: classes.downloadIcon }), _jsx(Box, { component: "h2", children: "Download the Repeat Mobile App" }), _jsx(Typography, { className: classes.subtext, children: "Choose your platform" }), _jsxs("div", { className: classes.appBrandWrapper, children: [_jsx(Button, { onClick: openGooglePlayURL, component: "a", "data-testid": "google-play-button", sx: { background: 'none', p: 0, minWidth: 0 }, children: _jsx("img", { src: "/img/mobile-app-promotions/google-play-badge.png", height: "45", alt: "Get it on Google Play", "data-testid": "google-play-badge" }) }), _jsx(Button, { onClick: openAppStoreURL, component: "a", "data-testid": "app-store-button", sx: { background: 'none', p: 0, minWidth: 0 }, children: _jsx("img", { src: "/img/mobile-app-promotions/app-store-badge.png", height: "45", alt: "Download on the App Store", "data-testid": "app-store-badge" }) })] })] }) })] }));
};
export default RepeatAppDownloadModal;
